/**
 * The build version this client bundle was built with.
 *
 * CI stamps VITE_APP_VERSION once per deploy (cd.yml's BUILD_VERSION): a release's version, such
 * as 0.0.8, or for a dev deploy the commit sha, shown as it is. A plain local build carries none
 * and reads "dev-local", which the server's client-version gate ignores. The same value is sent
 * as X-Client-Version on every request and shown on the About page (#411), so what the page says
 * is the build the server judges.
 *
 * Read at call time rather than captured at import, so a test can stub the environment.
 */
export function appVersion(): string {
  return import.meta.env.VITE_APP_VERSION ?? 'dev-local';
}
